import { Component } from '@angular/core';
import { ReportShareComponent } from '../../report-share.component';

@Component({
  selector: 'app-coachee-second-combinations',
  templateUrl: './coachee-second-combinations.component.html'
})
export class CoacheeSecondCombinationsComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.combinationDescTwo?.replaceAll("\n","<br />") ?? '';
  }

  get htmlCombination(): string {
    return this.report?.combinationDescThree?.replaceAll("\n","<br />") ?? '';
  }

}
